export const LOCATIONS = {
    POLAND: "Europe/Warsaw",
};
